import {BrowserRouter as Router, Routes,Route, Navigate} from 'react-router-dom'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import Homedash from './pages/Homedash';
import Login from './pages/Login';
import PrivacyPolicy from './pages/PrivacyPolicy';

import Home from './pages/Home';
import Register from './pages/Register';
import Header from './components/Header';
import NewWorker from './pages/NewWorker';
import Workers from './pages/Workers'
import VerifyUser from './pages/VerifyUser';

import PasswordReset from './pages/PasswordReset';
import WorkerPasswordReset from './pages/worker/WorkerPasswordReset';
import UserInfo from './pages/UserInfo';

import UpdateWorker from './pages/UpdateWorkerInfo'
import CreateJobSite from "./pages/CreateJobSite"
import JobSites from './pages/JobSites'

import WorkerOnboarding from './pages/worker/WorkerOnboarding'
import WorkerLogin from './pages/WorkerLogin'
import WorkerDash from './pages/worker/WorkerDash'
import WorkerCal from './pages/worker/WorkerCal'
import Punch from './pages/worker/Punch'

import AttendanceByJobsite from './pages/AttendanceByJobsite';
import AttendanceByWorker from './pages/AttendanceByWorker';


import PrivateRoute from './components/PrivateRoute';
import PrivateWorkerRoute from './components/PrivateWorkerRoute';
import PrivateSubscriptionRoutes from './components/PrivateSubscriptionRoutes';
import FacialLivenessMobileApp from './components/FacialLiveness_mobileApp';
import SetProfileImage from './components/SetProfileImage.jsx';


function App() {
      
      return(
            <>
                  <Router>
                     
                        {/* Public - Non protected Routes */}
                  
                        <Header/>
                              <Routes>
      
                              
                                    <Route exact path="/login" element={<Login />}></Route>
                                    <Route exact path="/workerLogin" element={<WorkerLogin />}></Route>
                                    <Route exact path="/register" element={<Register />}></Route>
                                    <Route exact path="/verify" element={<VerifyUser />}></Route>
                                    <Route exact path="/resetPassword" element={<PasswordReset />}> </Route>
                                    <Route exact path="/resetWorkerPassword" element={<WorkerPasswordReset />}> </Route>
                                    <Route exact path="/privacyPolicy" element={<PrivacyPolicy />}> </Route>
                                    
                                    {/* This is to be opened by mobile app browser,   */}
                                    {/* This is what we are currently working on */}
                                    <Route exact path="/mobilePunch/:webTicketId/:language" element={<FacialLivenessMobileApp />}> </Route>
                                    <Route exact path="/setProfileImage/:webTicketId/:language" element={<SetProfileImage />}> </Route>
                                    <Route exact path="/kioskPunch/:webTicketId/:language" element={<FacialLivenessMobileApp />}> </Route>
                                    
                  
                                  

                                    {/* PROTECTED PRIVATE WORKER USER ROUTES */}

                                    <Route path='/workerOnboarding' element={<PrivateWorkerRoute />}>
                                          <Route exact path="/workerOnboarding" element={<WorkerOnboarding />}></Route>  
                                    </Route>

                                    <Route path='/workerDash' element={<PrivateWorkerRoute />}>
                                          <Route index element={<WorkerDash />} />
                                    </Route>

                                    <Route path='/calendar/' element={<PrivateWorkerRoute />}>
                                          <Route index element={<WorkerCal />} />
                                    </Route>

                                    <Route path='/punch/:jobsiteId' element={<PrivateWorkerRoute />}>
                                          <Route index element={<Punch />} />
                                    </Route>



                                    {/* PROTECTED PRIVATE USER ROUTES */}
                                    {/* TODO : use index in all child protected pages */}
                                    <Route path='/homedash' element={<PrivateRoute />}>
                                          <Route element={<Homedash />} >
                                                <Route index element={<Navigate to="jobsites" replace />} />
                                                <Route path="jobsites" element={<JobSites />} />
                                                <Route path="workers" element={<Workers />} />
                                                <Route path="settings" element={<UserInfo />} />
                                          </Route>
                                    </Route>

                                    <Route path='/jobsite/attendance' element={<PrivateRoute />}>
                                          <Route index element={<AttendanceByJobsite />} />
                                    </Route>

                                    

                                    <Route path='/newJobSite' element={<PrivateRoute />}>
                                          <Route path='/newJobSite' element={<CreateJobSite />} />
                                    </Route>
                              

                                    <Route path='/jobSites' element={<PrivateRoute />}>
                                          <Route index element={<Navigate to="/homedash/jobsites" replace />} />
                                    </Route>

                                     <Route path='/worker/attendance' element={<PrivateRoute />}>
                                          <Route path='/worker/attendance' element={<AttendanceByWorker />} />
                                    </Route>



                                    {/* This was the old architecture, we will replace this with finger device */}
                                


                                    
      
                                    

                                    {/* Check user is logged in, then check subscription status, then render newWorker page */}
                                    <Route path='/new-worker' element={<PrivateRoute />}>
                                          <Route element={<PrivateSubscriptionRoutes />}>
                                                <Route index element={<NewWorker />} />
                                          </Route>
                                    </Route>


                                    <Route path='/workers' element={<PrivateRoute />}>
                                          <Route index element={<Navigate to="/homedash/workers" replace />} />
                                    </Route>

                                    <Route path='/workers/update' element={<PrivateRoute />}>
                                          <Route element={<PrivateSubscriptionRoutes />}>
                                                <Route index element={<UpdateWorker />} />
                                          </Route>
                                    </Route>
                                    
                                    
                                    

                                    
                                    <Route path='/userInfo' element={<PrivateRoute />}>
                                          <Route index element={<Navigate to="/homedash/settings" replace />} />
                                    </Route>

                                    <Route path='/jobsites' element={<PrivateRoute />}>
                                          <Route index element={<Navigate to="/homedash/jobsites" replace />} />
                                    </Route>

                                    <Route path="/" element={<Home/>}></Route>

                              </Routes>


                  </Router>
                  
                  <ToastContainer/>
                  
                  </>
  )
 
};

export default App;
